@if (show) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="faFileAlt"></fa-icon>
          <span>{{ 'INTERACTIONS.RESULTS.VIEW_LOG' | translate }}</span>
        </h3>
        <button class="close-btn" (click)="onClose()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        @if (loading) {
          <div class="log-loading">
            <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
            <span>{{ 'MESSAGE.LOADING' | translate }}</span>
          </div>
        }
        @if (!loading) {
          <div class="log-container">
            <pre class="log-content">{{ logContent }}</pre>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="close-button" (click)="onClose()">
          {{ 'BUTTON.CANCEL.GENERAL' | translate }}
        </button>
      </div>
    </div>
  </div>
}